export const MAP_SHOW = 'MAP_SHOW'
export const MAP_HIDE = 'MAP_HIDE'
export const MAP_SET_POINT = 'MAP_SET_POINT'
export const MAP_CHANGE_FLOOR = 'MAP_CHANGE_FLOOR'
export const MAP_CHANGE_ACCESSIBILITY = 'MAP_CHANGE_ACCESSIBILITY'

export const SEARCH_SHOW = 'SEARCH_SHOW'
export const SEARCH_HIDE = 'SEARCH_HIDE'
export const SEARCH_CHANGE_LIST_TYPE = 'SEARCH_CHANGE_LIST_TYPE'
export const SEARCH_CHANGE_FILTER = 'SEARCH_CHANGE_FILTER'


// WEBPACK FOOTER //
// ./constants/actions.js